import React, { useEffect } from 'react'

import NavBar from '../components/navbar'


export default function Editais() {
    useEffect(() => {
        function setTitle() {
            document.title = "Inove | Editais"
            document.body.style.background = "#eee"
        }

        setTitle()
    }, [])

    return (
        <div id="editais">
            <NavBar bgColor='rgb(68, 1, 91)'></NavBar>

            <div id="editais-content" className="my-5 py-5" style={{ backgroundColor: "#eee" }}>
                <div className="card w-75 mx-auto mt-5 shadow-sm">
                    <div className="row no-gutters">
                        <div className="card-body">
                            <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">
                                <a rel="noopener noreferrer" target="_blank" style={{ color: "rgb(68, 1, 91)" }} href="https://www.quixada.ufc.br/wp-content/uploads/2019/07/Seleção_bolsistas_pibic_jogos.pdf">Edital PIBIC</a>
                            </h5>
                            <span id="data" className="card-text text-muted my-0 py-0">Publicado em: 18/09/2019</span>

                            <p id="descricao" className="card-text mt-4">Identificação de Padrões e Definição de Diretrizes para Construção de Componentes Específicos de Interfaces em Jogos de Realidade Virtual</p>

                            <div className="p-2 m-0 card-footer">
                                <p>Outros links relacionados:</p>
                                <ul className="m-0">
                                    <li>
                                        <a href="#" className="p-0 m-0">link1</a>
                                    </li>

                                    <li>
                                        <a href="#" className="p-0 m-0">link2</a>
                                    </li>

                                    <li>
                                        <a href="#" className="p-0 m-0">link3</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card w-75 mx-auto mt-5 shadow-sm">
                    <div className="row no-gutters">
                        <div className="card-body">
                            <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">
                                <a rel="noopener noreferrer" target="_blank" style={{ color: "rgb(68, 1, 91)" }} href="https://www.quixada.ufc.br/wp-content/uploads/2019/07/Seleção_bolsistas_pibic_jogos.pdf">Edital PIBIC</a>
                            </h5>
                            <span id="data" className="card-text text-muted my-0 py-0">Publicado em: 18/09/2019</span>

                            <p id="descricao" className="card-text mt-4">Identificação de Padrões e Definição de Diretrizes para Construção de Componentes Específicos de Interfaces em Jogos de Realidade Virtual</p>
                        </div>
                    </div>
                </div>

                <div className="card w-75 mx-auto mt-5 shadow-sm">
                    <div className="row no-gutters">
                        <div className="card-body">
                            <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">
                                <a rel="noopener noreferrer" target="_blank" style={{ color: "rgb(68, 1, 91)" }} href="https://www.quixada.ufc.br/wp-content/uploads/2019/07/Seleção_bolsistas_pibic_jogos.pdf">Edital PIBIC</a>
                            </h5>
                            <span id="data" className="card-text text-muted my-0 py-0">Publicado em: 18/09/2019</span>

                            <p id="descricao" className="card-text mt-4">Identificação de Padrões e Definição de Diretrizes para Construção de Componentes Específicos de Interfaces em Jogos de Realidade Virtual</p>
                        </div>
                    </div>
                </div>

                <div className="card w-75 mx-auto mt-5 shadow-sm">
                    <div className="row no-gutters">
                        <div className="card-body">
                            <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">
                                <a rel="noopener noreferrer" target="_blank" style={{ color: "rgb(68, 1, 91)" }} href="https://www.quixada.ufc.br/wp-content/uploads/2019/07/Seleção_bolsistas_pibic_jogos.pdf">Edital PIBIC</a>
                            </h5>
                            <span id="data" className="card-text text-muted my-0 py-0">Publicado em: 18/09/2019</span>

                            <p id="descricao" className="card-text mt-4">Identificação de Padrões e Definição de Diretrizes para Construção de Componentes Específicos de Interfaces em Jogos de Realidade Virtual</p>
                        </div>
                    </div>
                </div>

                <div className="card w-75 mx-auto mt-5 shadow-sm">
                    <div className="row no-gutters">
                        <div className="card-body">
                            <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">
                                <a rel="noopener noreferrer" target="_blank" style={{ color: "rgb(68, 1, 91)" }} href="https://www.quixada.ufc.br/wp-content/uploads/2019/07/Seleção_bolsistas_pibic_jogos.pdf">Edital PIBIC</a>
                            </h5>
                            <span id="data" className="card-text text-muted my-0 py-0">Publicado em: 18/09/2019</span>

                            <p id="descricao" className="card-text mt-4">Identificação de Padrões e Definição de Diretrizes para Construção de Componentes Específicos de Interfaces em Jogos de Realidade Virtual</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}